import { render, staticRenderFns } from "./look-2026.vue?vue&type=template&id=4c7edbfa&scoped=true"
import script from "./look-2026.vue?vue&type=script&lang=js"
export * from "./look-2026.vue?vue&type=script&lang=js"
import style0 from "./look-2026.vue?vue&type=style&index=0&id=4c7edbfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7edbfa",
  null
  
)

export default component.exports